import React from 'react';
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useCart } from '../context/CartContext';
import { Helmet } from "react-helmet";

function Checkout() {
  const { cartItems, getCartTotal, clearCart } = useCart();
  const navigate = useNavigate();

  const [formData, setFormData] = useState({
    firstName: '',
    lastName: '',
    email: '',
    phone: '',
    address: '',
    city: '',
    postalCode: '',
    notes: ''
  });

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    clearCart();
    navigate('/success');
  };

  if (cartItems.length === 0) {
    return (
      <div className="checkout-form-container">
        <h1 className="checkout-title">Το καλάθι σας είναι άδειο</h1>
        <p style={{ textAlign: 'center', marginBottom: '2rem' }}>
          Προσθέστε προϊόντα στο καλάθι σας για να συνεχίσετε.
        </p>
        <button onClick={() => navigate('/')} className="btn btn-primary">
          Επιστροφή στην Αρχική
        </button>
      </div>
    );
  }

  return (
    <>
      <Helmet>
        <title>Sororin - Κατάστημα Ομορφιάς</title>
        <meta name="description" content="Sororin - Κατάστημα Ομορφιάς με προϊόντα υψηλής ποιότητας. Ανακαλύψτε την πολυτελή συλλογή μας από προϊόντα περιποίησης και ομορφιάς." />
      </Helmet>

      <div className="checkout-form-container">
      <h1 className="checkout-title">Ολοκλήρωση Παραγγελίας</h1>

      <div className="order-summary">
        <h3>Η Παραγγελία σας</h3>
        {cartItems.map(item => (
          <div key={item.id} className="order-item">
            <span>{item.name} x {item.quantity}</span>
            <span>€{(item.price * item.quantity).toFixed(2)}</span>
          </div>
        ))}
        <div className="order-total">
          <span>Σύνολο</span>
          <span>€{getCartTotal().toFixed(2)}</span>
        </div>
      </div>

      <form onSubmit={handleSubmit} className="checkout-form">
        <h3 style={{ marginBottom: '1.5rem', color: 'var(--dark-rose)' }}>
          Στοιχεία Αποστολής
        </h3>

        <div className="form-group">
          <label htmlFor="firstName">Όνομα *</label>
          <input
            type="text"
            id="firstName"
            name="firstName"
            value={formData.firstName}
            onChange={handleChange}
            required
          />
        </div>

        <div className="form-group">
          <label htmlFor="lastName">Επώνυμο *</label>
          <input
            type="text"
            id="lastName"
            name="lastName"
            value={formData.lastName}
            onChange={handleChange}
            required
          />
        </div>

        <div className="form-group">
          <label htmlFor="email">Email *</label>
          <input
            type="email"
            id="email"
            name="email"
            value={formData.email}
            onChange={handleChange}
            required
          />
        </div>

        <div className="form-group">
          <label htmlFor="phone">Τηλέφωνο *</label>
          <input
            type="tel"
            id="phone"
            name="phone"
            value={formData.phone}
            onChange={handleChange}
            required
          />
        </div>

        <div className="form-group">
          <label htmlFor="address">Διεύθυνση *</label>
          <input
            type="text"
            id="address"
            name="address"
            value={formData.address}
            onChange={handleChange}
            required
          />
        </div>

        <div className="form-group">
          <label htmlFor="city">Πόλη *</label>
          <input
            type="text"
            id="city"
            name="city"
            value={formData.city}
            onChange={handleChange}
            required
          />
        </div>

        <div className="form-group">
          <label htmlFor="postalCode">Ταχυδρομικός Κώδικας *</label>
          <input
            type="text"
            id="postalCode"
            name="postalCode"
            value={formData.postalCode}
            onChange={handleChange}
            required
          />
        </div>

        <div className="form-group">
          <label htmlFor="notes">Σημειώσεις Παραγγελίας</label>
          <textarea
            id="notes"
            name="notes"
            value={formData.notes}
            onChange={handleChange}
            placeholder="Πρόσθετες οδηγίες για την παράδοση"
          ></textarea>
        </div>

        <button type="submit" className="btn btn-primary" style={{ width: '100%', marginTop: '1rem' }}>
          Ολοκλήρωση Παραγγελίας
        </button>
      </form>
    </div>
  
    </>);
}

export default Checkout;